import { docodeHexResponse } from "../../_common/common.utils";
import SubmittedProposalsReportTypes from "./submittedProposalsReport.types";

const INITIAL_STATE: any = {
  submittedProposalsReportFetchResponseArr: [],
  submittedProposalsReportFetchResponse: null,
  submittedProposalsReportExportResponse: null,
  submittedProposalsReportExportResponseArr: [],
  exportSubmittedProposalsReportStatus: "",
};

const submittedProposalsReportReducer = (
  state = INITIAL_STATE,
  action: any,
) => {
  switch (action.type) {
    case SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_FETCH_SUCCESS:
      return {
        ...state,
        submittedProposalsReportFetchResponse: action.payload,
        submittedProposalsReportFetchResponseArr: docodeHexResponse(
          action.payload,
          "SubmittedProposalsJsonKey",
        ),
      };

    case SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_FETCH_FAILURE:
      return {
        ...state,
        submittedProposalsReportFetchResponse: action.payload,
        submittedProposalsReportFetchResponseArr: [],
      };

    case SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_FETCH_RESPONSE_CHANGED:
      return { ...state, submittedProposalsReportFetchResponse: null };

    case SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_EXPORT_SUCCESS:
      return {
        ...state,
        submittedProposalsReportExportResponse: action.payload,
        submittedProposalsReportExportResponseArr: docodeHexResponse(
          action.payload,
          "CreateRequestReportKey",
        ),
        exportSubmittedProposalsReportStatus: "Success",
      };

    case SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_EXPORT_FAILURE:
      return {
        ...state,
        submittedProposalsReportExportResponse: action.payload,
        submittedProposalsReportExportResponseArr: [],
        exportSubmittedProposalsReportStatus: "Failure",
      };

    case SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_EXPORT_CHANGED:
      return {
        ...state,
        submittedProposalsReportExportResponse: null,
        exportSubmittedProposalsReportStatus: "",
      };

    default:
      return state;
  }
};

export default submittedProposalsReportReducer;
